import { render, staticRenderFns } from "./FarmWorkRecordPopup.vue?vue&type=template&id=72696c50&scoped=true&"
import script from "./FarmWorkRecordPopup.vue?vue&type=script&lang=js&"
export * from "./FarmWorkRecordPopup.vue?vue&type=script&lang=js&"
import style0 from "./FarmWorkRecordPopup.vue?vue&type=style&index=0&id=72696c50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72696c50",
  null
  
)

export default component.exports